module.exports = __webpack_public_path__ + "static/media/pl_8_offline.b977ba20.png";